import { render, staticRenderFns } from "./ExtActProcessFormModal.vue?vue&type=template&id=55286d5c&scoped=true&"
import script from "./ExtActProcessFormModal.vue?vue&type=script&lang=js&"
export * from "./ExtActProcessFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55286d5c",
  null
  
)

export default component.exports